const baseUrl="https://chatapp-aipw.onrender.com"

//  const baseUrl="http://localhost:8000"
export default baseUrl